import { FC } from 'react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { useFinancialWorkspace } from 'modules/finance/components/FinancialWorkspace/Providers/Provider'
import { DEFAULT_CURRENCY } from 'modules/finance/components/FinancialWorkspace/components/Table/const'
import { WEIGHT } from 'modules/finance/components/FinancialWorkspace/components/Table/table/Row/const'
import { TableItemData } from 'modules/finance/components/FinancialWorkspace/types/table'
import { Amount } from 'modules/project_management/components/Amount'

interface CellProps {
  cell?: TableItemData
  showBlank?: boolean
  level: number
  italic?: boolean
}

export const Cell: FC<CellProps> = ({ cell, showBlank, level, italic }) => {
  const { supportedCurrencies } = useFinancialWorkspace()
  const { company } = useCurrentSession()
  const currency = supportedCurrencies.includes(String(company.currency))
    ? company.currency
    : DEFAULT_CURRENCY

  if (cell?.isSummarized || cell?.isUngrouped || showBlank) return <></>

  return (
    <Amount
      size="200"
      italic={italic}
      color="grey1000"
      weight={WEIGHT[level]}
      optionalDecimals={false}
      currency={String(currency)}
      amount={Number(cell?.totalAmountInCents) || null}
    />
  )
}
